import { useEffect, useState } from 'react';
import { useStore } from '../../../utils/store';
import Constants from '../../../utils/constants';
import HttpService from '../../../services/HttpService';
import { useSearch } from '../../../components/searchContext';
import { Box, LinearProgress, Paper, Typography } from '@mui/material';

import CustomPaginationActionsTable from '../../../components/TablePagination';

import AlertMessageComponent from '../../../components/AlertMessageComponent';
import { getFormatDate } from '../../../utils/storageUtil';
import { useAlert } from '../../../components/alertContext';

interface ProjectCommunicationsProps {
  projectInternalId: number;
}
const ProjectCommunications: React.FC<ProjectCommunicationsProps> = ({
  projectInternalId,
}) => {
  const { searchQuery } = useSearch();

  const { getAdmin } = useStore();
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const columns: any[] = [
    {
      field: 'id',
      headerName: 'Date',

      renderCell: (value: any, row: any) => getFormatDate(row.date),
    },
    {
      field: 'id',
      headerName: 'Document Name',
      renderCell: (value: any, row: any) => row.name,
    },
    {
      field: 'id',
      headerName: 'Sent Date',
      renderCell: (value: any, row: any) => getFormatDate(row.sentDate),
    },
  ];
  const [paginate, setPaginate] = useState<any>({
    limit: Constants.DEFAULT_PAGE_SIZE,
    offset: 0,
  });
  const { alert, setAlert, handleCloseAlert } = useAlert();
  const [isLoading, setIsLoading] = useState(false);
  const [rows, setRows] = useState<any>([]);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const response = await HttpService.get(
        `${Constants.apiURL}${Constants.projectDashboardsURL}/${projectInternalId}/communication`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        {
          search: searchQuery,
          limit: paginate.limit,
          offset: paginate.offset,
          isActive: 1,
        }
      );
      setIsLoading(false);
      if (response.success) {
        setRows(response.data.paginateRecords);
        setTotalRecords(response.data.total);
      }
      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`GET ERROR:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };

  const handlePagination = (paginationData: any) => {
    console.log(paginationData);
    setPaginate(paginationData);
  };

  useEffect(() => {
    if (paginate) {
      fetchData();
    }
  }, [paginate]);

  return (
    <div className="containergrid">
      <div className="mt-2">
        <Paper sx={{ width: '100%' }} className="mt-4">
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '10px',
              mb: 2,
            }}
          >
            <Typography variant="h6">All Communications</Typography>
          </Box>
          {isLoading && (
            <Box sx={{ width: '100%', mt: 3 }}>
              <LinearProgress />
            </Box>
          )}
          <CustomPaginationActionsTable
            rows={rows}
            columns={columns}
            totalRecords={totalRecords}
            handlePagination={handlePagination}
            handleRowClick={(row) => {
              console.log('row-clicked');
            }}
            paginationModel={{
              page: paginate.offset,
              pageSize: paginate.limit,
            }}
            handleStatus={() => {}}
          />

          <AlertMessageComponent
            type={alert.type}
            open={alert.open}
            handleClose={handleCloseAlert}
            message={alert.message}
          />
        </Paper>
      </div>
    </div>
  );
};

export default ProjectCommunications;
